/**
 * Curated imagery for the Bangkok 2026 conference theme.
 * All paths are served from /public.
 */
export const BANGKOK = {
  heroBanner: {
    src: '/assets/images/slider/banner-04.webp',
    alt: 'ISBM 2026 conference — Bangkok',
  },
  bangkokSkyline: {
    src: '/assets/images/bangkok.webp',
    alt: 'Bangkok city skyline',
  },
  newBangkok: {
    src: '/assets/images/new-bangkok.webp',
    alt: 'Bangkok cityscape',
  },
  bangkok1: {
    src: '/assets/images/bangkok-1.webp',
    alt: 'Bangkok — ISBM 2026 host city',
  },
  skyline: {
    src: '/assets/images/venue/location/bangkok.webp',
    alt: 'Bangkok skyline at sunset along the Chao Phraya River',
  },
  slider1: {
    src: '/assets/images/slider/benner01.jpg',
    alt: 'International conference panel discussion',
  },
  slider2: {
    src: '/assets/images/slider/benner02.webp',
    alt: 'Business and technology leaders at a global forum',
  },
  slider3: {
    src: '/assets/images/slider/benner03.webp',
    alt: 'Conference auditorium with delegates',
  },
  event1: {
    src: '/gallery/2025/home/1.webp',
    alt: 'ISBM conference delegates in Bangkok',
  },
  event2: {
    src: '/gallery/2025/home/2.jpg',
    alt: 'Networking session at ISBM Bangkok',
  },
  event3: {
    src: '/gallery/2025/home/3.jpg',
    alt: 'Keynote and plenary at ISBM',
  },
  event4: {
    src: '/gallery/2025/home/16.jpg',
    alt: 'Conference registration and welcome in Bangkok',
  },
  bangkokSkylineVenue: {
    src: '/assets/images/venue/location/Bangkok Skyline.webp',
    alt: 'Bangkok skyline — ISBM 2026',
  },
  publicationBanner: {
    src: '/assets/images/publication-banner.webp',
    alt: 'ISBM publications — Springer Nature proceedings',
  },
  venueBanner: {
    src: '/assets/images/venue-banner.webp',
    alt: 'ISBM 2026 venue — Bangkok, Thailand',
  },
  contactBanner: {
    src: '/assets/images/new-contact.webp',
    alt: 'ISBM 2026 — Contact Us',
  },
  thailandHero: {
    src: '/assets/images/Thailand.webp',
    alt: 'Thailand — ISBM 2026 host country',
  },
  testimonialsBanner: {
    src: '/assets/images/register_banner.webp',
    alt: 'ISBM 2026 delegates — testimonials',
  },
  speakersBanner: {
    src: '/assets/images/gallery-banner.webp',
    alt: 'ISBM speaker presenting to the audience',
  },
};

/** Default hero image per route (pathname without hash). */
export const PAGE_HERO_IMAGES = {
  '/call-for-papers': BANGKOK.bangkok1,
  '/cfp': BANGKOK.bangkok1,
  '/speakers': BANGKOK.speakersBanner,
  '/publications': BANGKOK.publicationBanner,
  '/registration': BANGKOK.event4,
  '/register/paper': BANGKOK.event4,
  '/committees': BANGKOK.event2,
  '/join-us': BANGKOK.contactBanner,
  '/venue': BANGKOK.venueBanner,
  '/gallery': BANGKOK.event1,
  '/agenda': BANGKOK.slider3,
  '/contact-us': BANGKOK.contactBanner,
  '/testimonials': BANGKOK.testimonialsBanner,
  '/feedback': BANGKOK.testimonialsBanner,
  '/paper-submission': BANGKOK.slider2,
  '/author-guidelines': BANGKOK.slider1,
  '/attendance': BANGKOK.event4,
  '/zoom-link': BANGKOK.slider3,
  '/zoom': BANGKOK.slider3,
  '/terms-conditions': BANGKOK.skyline,
  '/terms': BANGKOK.skyline,
  '/legal-information': BANGKOK.skyline,
  '/legal': BANGKOK.skyline,
  '/participation-policy': BANGKOK.event2,
  '/policy': BANGKOK.event2,
};

export function getPageHeroImage(pathname) {
  return PAGE_HERO_IMAGES[pathname] ?? BANGKOK.skyline;
}
